import React from "react";
import { default as MUIDrawer } from "@mui/material/Drawer";
import styled from "styled-components";

const StyledMUIDrawer = styled(MUIDrawer)``;

/**
 * Drawer component that wraps Material UI's Drawer with styling
 *
 * @component
 * @param {'left'|'right'|'top'|'bottom'} [props.anchor='left'] - Side from which the drawer slides in
 * @param {boolean} props.open - If true, the drawer is opened
 * @param {Function} props.onClose - Callback fired when the drawer requests to be closed
 * @param {boolean} [props.hideBackdrop=false] - If true, the backdrop is not rendered
 * @param {React.ReactNode} props.children - The content of the drawer
 * @returns {JSX.Element} The rendered Drawer component
 *
 * @example
 * <Drawer
 *   anchor="left"
 *   open={isOpen}
 *   onClose={() => setIsOpen(false)}
 *   hideBackdrop={false}
 * >
 *   <DrawerContent />
 * </Drawer>
 */
export const Drawer = ({
  anchor,
  open,
  onClose,
  hideBackdrop = false,
  children,
  variant = "temporary",
  sx,
}) => {
  return (
    <StyledMUIDrawer
      anchor={anchor}
      hideBackdrop={hideBackdrop}
      open={open}
      onClose={onClose}
      variant={variant}
      sx={{
        ...(sx !== null && sx !== undefined ? sx : {}),
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      {children}
    </StyledMUIDrawer>
  );
};
